import * as React from 'react';

export const Attach = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.65 3.75C7.49621 3.75 5.75 5.49621 5.75 7.65V14C5.75 17.4518 8.54821 20.25 12 20.25C15.4518 20.25 18.25 17.4518 18.25 14V4.881C18.25 4.46679 18.5858 4.131 19 4.131C19.4142 4.131 19.75 4.46679 19.75 4.881V14C19.75 18.2802 16.2802 21.75 12 21.75C7.71979 21.75 4.25 18.2802 4.25 14V7.65C4.25 4.66779 6.66779 2.25 9.65 2.25C12.6322 2.25 15.05 4.66779 15.05 7.65V13.844C15.05 15.5538 13.6636 16.942 11.953 16.942C10.2416 16.942 8.855 15.554 8.855 13.844V7.999C8.855 7.58479 9.19079 7.249 9.605 7.249C10.0192 7.249 10.355 7.58479 10.355 7.999V13.844C10.355 14.726 11.0704 15.442 11.953 15.442C12.8344 15.442 13.55 14.7262 13.55 13.844V7.65C13.55 5.49621 11.8038 3.75 9.65 3.75Z"
      fill="#64748B"
    />
  </svg>
);
